import { render, staticRenderFns } from "./ProductSIL.vue?vue&type=template&id=5268e878&"
import script from "./ProductSIL.vue?vue&type=script&lang=js&"
export * from "./ProductSIL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports